import React, { useEffect } from "react";
import { useDispatch, useStore } from "react-redux";

import { SOCIAL_LOGIN_TRIGGER } from "@/mk2/apps/users/containers/SocialAuth/SocialAuth.actions";
import { socialAuthReducer } from "@/mk2/apps/users/containers/SocialAuth/SocialAuth.reducers";
import { socialAuthSaga } from "@/mk2/apps/users/containers/SocialAuth/SocialAuth.sagas";
import { SOCIAL_LOGIN_ENABLED } from "@/mk2/apps/users/lib/socialAuth/config";
import { SocialProvider } from "@/mk2/apps/users/lib/socialAuth/types";
import { HistoryLocationWithState } from "@/mk2/services/browserHistory";
import { Store } from "@/mk2/store/configureStore";
import {
    OR,
    SOCIAL_LOGIN_WITH_GOOGLE,
    SOCIAL_SIGNUP_WITH_GOOGLE,
} from "@/mk/autogenerated/translation";

import styles from "./SocialAuthButtons.mscss";

interface Props {
    mode: "signup" | "login";
    location: HistoryLocationWithState;
}

export const SocialAuthButtons: React.FC<Props> = ({ mode, location }) => {
    const dispatch = useDispatch();
    const store = useStore() as Store<any>;

    useEffect(() => {
        store.injectReducer("containers.users.socialAuth", socialAuthReducer);
        store.injectSaga("containers.users.socialAuth", socialAuthSaga);
    }, [store]);

    if (!SOCIAL_LOGIN_ENABLED) {
        return null;
    }

    const handleClick = (provider: SocialProvider) => {
        const action = {
            type: SOCIAL_LOGIN_TRIGGER,
            provider,
            location,
        };
        dispatch(action);
    };

    const label = mode === "signup" ? SOCIAL_SIGNUP_WITH_GOOGLE : SOCIAL_LOGIN_WITH_GOOGLE;

    return (
        <div className={styles.SocialAuthButtons}>
            <button
                type="button"
                className={
                    styles.SocialAuthButtons__button + " " + styles.SocialAuthButtons__google
                }
                onClick={() => handleClick("google")}
            >
                <svg
                    className={styles.SocialAuthButtons__icon}
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                >
                    <path
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        fill="#4285F4"
                    />
                    <path
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        fill="#34A853"
                    />
                    <path
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                        fill="#FBBC05"
                    />
                    <path
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        fill="#EA4335"
                    />
                </svg>
                <span>{label}</span>
            </button>

            <div className={styles.SocialAuthButtons__separator}>
                <span>{OR}</span>
            </div>
        </div>
    );
};
